import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntSwitchComponent } from "./int-switch.component";
import {IntAttrBindingModule} from "../../directives";


@NgModule({
  imports: [
    CommonModule,
    IntAttrBindingModule
  ],
  declarations: [
    IntSwitchComponent
  ],
  exports: [
    IntSwitchComponent
  ]
})
export class IntSwitchModule { }
